import * as React from 'react'

import { CounselingLP as Presenter, IProps } from './presenter'

export const CounselingLP = (props: IProps): JSX.Element => {
  return <Presenter {...props} />
}

export default CounselingLP
